const BRAZIL_COUNTRY_CODE = "55";

export function normalizePhoneDigits(phone?: string | null): string {
  if (!phone) {
    return "";
  }
  return phone.replace(/\D/g, "");
}

/**
 * wa.me needs the number in international format. Phones are stored with the area
 * code only, e.g. (85) 98765-4321; without the country code WhatsApp on iOS cannot
 * resolve the contact and shows the number prefixed with "@".
 */
export function toWhatsAppNumber(phone?: string | null): string {
  const digits = normalizePhoneDigits(phone);
  // "+" means the country code is already there.
  if (phone?.trim().startsWith("+")) {
    return digits;
  }
  // Leading zeros come from trunk/carrier dialing prefixes such as 085.
  const local = digits.replace(/^0+/, "");
  if (local.length === 10 || local.length === 11) {
    return `${BRAZIL_COUNTRY_CODE}${local}`;
  }
  return local;
}

export function buildWhatsAppLink(phone?: string | null): string | null {
  const number = toWhatsAppNumber(phone);
  if (!number) {
    return null;
  }
  return `https://wa.me/${number}`;
}
